export default "__VITE_ASSET__CLr42GYo__";